import styles from './styles.module.css';

function ConfirmDeleteModal({ onConfirm, onCancel }) {
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h3>Excluir nota</h3>

        <p>
          Tem certeza que deseja excluir esta nota?
        </p>

        <div className={styles.warning}>
          ⚠️ Excluir uma nota não libera espaço no limite do seu plano.
        </div>

        <div className={styles.buttons}>
          <button className={styles.cancel} onClick={onCancel}>
            Cancelar
          </button>

          <button className={styles.delete} onClick={onConfirm}>
            Excluir nota
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDeleteModal;